<template>
    <el-card class="reception-list-container">
        <div class="reception-export">
            <el-tooltip
                v-if="activeName === 'sixth'"
                effect="dark"
                :content="$t('tooltip.export')"
                placement="bottom">
                <div
                    @click="handleExport()"
                    class="iconfont icon-fitness-daochu sell-index-export">
                </div>
            </el-tooltip>
        </div>
        <div class="reception-content">
            <el-tabs v-model="activeName" @tab-click="handleClick">

                <el-tab-pane
                    v-if="$$filterPermission('前台-会员出入场登记-出入场登记')"
                    :label="$t('Reception.First.title')"
                    name="first"
                    :lazy="true"
                    v-once>
                    <client-registration />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('前台-来访预约登记-来访预约出入场登记')"
                    :label="$t('Reception.Second.title')"
                    name="second"
                    :lazy="true"
                    v-once>
                    <visit-registration />
                </el-tab-pane>

                <el-tab-pane
                    :label="$t('Reception.Third.title')"
                    name="third"
                    :lazy="true"
                    v-once>
                    <save-record />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('前台-钥匙牌管理-钥匙牌搜索及查看')"
                    :label="$t('Reception.Fourth.title')"
                    name="fourth"
                    :lazy="true"
                    v-once>
                    <temporary-locker />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('前台-租赁柜管理-租赁柜搜索及查看')"
                    :label="$t('Reception.Fifth.title')"
                    name="fifth"
                    :lazy="true"
                    v-once>
                    <rental-cabinet />
                </el-tab-pane>

                <el-tab-pane
                    v-if="$$filterPermission('前台-出入场查询-仅查看分配给自己的') || $$filterPermission('前台-出入场查询-查看全部')"
                    :label="$t('Reception.Sixth.title')"
                    name="sixth"
                    :lazy="true"

                    v-once>
                    <enter-query ref="enter" />
                </el-tab-pane>
            </el-tabs>

        </div>
    </el-card>
</template>

<script>
import { Tabs, TabPane } from 'element-ui';
import TemporaryLocker from '@/components/widget/Reception/TemporaryLocker';
import RentalCabinet from '@/components/widget/Reception/RentalCabinet';
import NewCustomer from '@/components/Dialog/NewCustomer';
import SaveRecord from '@/components/TableCom/Reception/SaveRecord';
import EnterQuery from "@/components/TableCom/Reception/EnterQuery";
import ClientRegistration from "@/components/TableCom/Reception/ClientRegistration";
import VisitRegistration from "../../components/TableCom/Reception/VisitRegistration";

export default {
    components: {
        VisitRegistration,
        ClientRegistration,
        ElTabs: Tabs,
        ElTabPane: TabPane,
        TemporaryLocker,
        RentalCabinet,
        NewCustomer,
        SaveRecord,
        EnterQuery,
    },
    mixins: [require('../../mixins/CacheQuery').default],
    data() {
        return {
            editableTabs: [
                {
                    name: 'first',
                    isShow: this.$$filterPermission('前台-会员出入场登记-出入场登记'),
                }, {
                    name: 'second',
                    isShow: this.$$filterPermission('前台-来访预约登记-来访预约出入场登记'),
                }, {
                    name: 'third',
                    isShow: true,
                }, {
                    name: 'fourth',
                    isShow: true,
                }, {
                    name: 'fifth',
                    isShow: this.$$filterPermission('前台-租赁柜管理-租赁柜搜索及查看'),
                }, {
                    name: 'sixth',
                    isShow: this.$$filterPermission('前台-出入场查询-仅查看分配给自己的')
                    || this.$$filterPermission('前台-出入场查询-查看全部'),
                },
            ],
        };
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        handleClick(tab, event) {},
        // 导出
        handleExport() {
            this.$refs.enter.handleExport();
        },
    },
};
</script>

<style lang="scss">
.reception-list-container {
    min-width: 1200px;
}
.reception-content {
    color: #666;
}
.reception-export {
    position: relative;
    float: right;
    right: 0;
    top: 16px;
    z-index: 2;
    padding: 0;
    margin: 0;
}
.reception-form {
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 15px;
}
.label {
    white-space: nowrap;
    margin: 0 10px 0 0;
    font-size: 14px;
}
.label-2 {
    white-space: nowrap;
    margin: 0 10px 0 10px;
    font-size: 14px;
}
.reception-nickname {
    width: 375px;
}
.member-info,
.member-avator {
    width: 22%;
    margin-right: 1%;
    border: 1px solid #e6e6e6;
    display: inline-block;
    vertical-align: text-top;
}
.member-desc {
    width: 54%;
    display: inline-block;
    vertical-align: text-top;
}
.member-desc-item {
    margin-bottom: 15px;
    border: 1px solid #e6e6e6;
    .el-radio__label {
        display: none !important;
    }
}
.member-title {
    font-size: 13px;
    background: #fafafa;
    padding: 18px 20px;
    border-bottom: 1px solid #e6e6e6;
}
.member-info-content {
    div {
        font-size: 12px;
        padding: 10px 0;
        margin: 0 20px;
    }
    .member-info-remarks {
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        margin: 10px 20px 20px;
        padding: 15px 0;
        div {
            margin: 0;
            padding: 0;
        }
    }
}
.member-avator-pic {
    width: 100%;
    padding: 15px;
    position: relative;
}
.member-avator-bg {
    height: calc(100vw / (329 * 1 / 468) * 0.16);
    background: #697a8e;
    background-size: cover;
    background-position: center;
}
.member-avator-icon {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 150px;
}
.member-membership {
    padding: 15px;
}
.member-radio {
    .el-radio__label {
        display: none;
    }
}
.reception-member-appoint {
    border-bottom: 1px solid #e6e6e6;
    padding-bottom: 15px;
    margin-bottom: 15px;
}
.member-receptionist {
    margin-left: 1%;
    width: 20%;
    padding: 10px 15px;
    margin-bottom: 15px;
    border: 1px solid #e6e6e6;
    background: #f7f7f7;

    .handle-temporary-btn {
        margin-top: 10px;
    }
}
.search-sale {
    width: calc(100% - 40px);
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    height: 28px;
    outline: none;
}
.flex-column {
    flex-direction: column;
}
.receptionist-handle {
    padding: 15px;
    border: 1px solid #e6e6e6;
}
</style>
